import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import { East, WhereToVoteOutlined } from "@mui/icons-material";
import moment from "moment";

import Modal from "../../../Common/Modal/Modal";
import SegmentDetails from "../Segment Details/SegmentDetails";
import classes from "./FlightDetails.module.css";
import FlightProviders from "../../utils/FlightProviders";
import { ReactComponent as LuggageIcon } from "../../../../assets/img/icons/luggage.svg";
import { ReactComponent as ScheduleIcon } from "../../../../assets/img/icons/schedule.svg";
import { ReactComponent as ShoppingCartIcon } from "../../../../assets/img/icons/shopping_cart_checkout.svg";
import { useLocation } from "react-router-dom";
const getDateDifference = (d1, d2) => {
  //d1 > d2
  let a = moment(d1);
  let b = moment(d2);

  let min = a.diff(b, "minutes");
  let hr = a.diff(b, "hours");
  return hr + "h " + (min - hr * 60) + "m";
};

export default function FlightDetails({
  flightDetails,
  show,
  closeDetails,
  history,
}) {
  const currency = useSelector((state) => state.flight.currency);
  const dispatch = useDispatch();
  const search = useLocation().search;
  if (!flightDetails) return <></>;
  const journeyType = new URLSearchParams(search).get('journeyType');
  const departureDate = new URLSearchParams(search).get('selectedDepartureDate');
  const arrivalDate = new URLSearchParams(search).get('arrivalDate');
  const adults = new URLSearchParams(search).get('adults');
  const flightClass = new URLSearchParams(search).get('flightClass');
  const departureAirport = new URLSearchParams(search).get('departureAirport');
  const arrivalAirport = new URLSearchParams(search).get('arrivalAirport');
  const kids = new URLSearchParams(search).get('kids');
  const infants = new URLSearchParams(search).get('infants');
  function getFormattedStartDate(dateString) {
    const date = new Date(dateString);
    const days = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    return `${days[date.getDay()].substring(0, 3)} ${date.getDate()} ${months[
      date.getMonth()
    ]
      .toUpperCase()
      .substring(0, 3)}`;
  }

  function proceedToPayments() {
    dispatch({ type: "SELECTED_FLIGHT", flight: flightDetails });
    console.log('Fight details::'+flightDetails)
    // history.push(
    //   `/flights-book/v${flightDetails.provider}/${flightDetails.provider === FlightProviders.KIWI ? flightDetails.booking_token : flightDetails.flight_id}?journeyType=${journeyType}&departureAirport=${departureAirport}&arrivalAirport=${arrivalAirport}&departureDate=${selectedDepartureDate}&arrivalDate=${selectedArrivalDate}&adults=${adults}&kids=${kids}&infants=${infants}&flightClass=${flightClass}`
    // );
    history.push(
      `/flights-book/v${
        flightDetails.provider === FlightProviders.AIRIQ ? 'book4' : flightDetails.provider
      }/${
        flightDetails.provider === FlightProviders.KIWI
          ? flightDetails.booking_token
          : flightDetails.provider === FlightProviders.AIRIQ 
          ? flightDetails.ticked_id
          : flightDetails.flight_id
      }?journeyType=${journeyType}&departureAirport=${departureAirport}&arrivalAirport=${arrivalAirport}&departureDate=${departureDate}&arrivalDate=${arrivalDate}&adults=${adults}&kids=${kids}&infants=${infants}&flightClass=${flightClass}`
    );
  }
  return (
    <Modal show={show} onClose={closeDetails} title="Itinerary Details">
      <>
        {flightDetails.slices.map((airport, index) => (
          <div style={{ marginBottom: "3rem" }}>
            <div className={classes["journey-title"]}>
              <div className={classes["journey__src-dst"]}>
                <Typography className={classes["cityTo-heading"]} variant="h5">
                  {index === 0
                    ? flightDetails?.cityFrom
                    : flightDetails?.cityTo}
                </Typography>
                <East />
                <Typography
                  className={classes["cityFrom-heading"]}
                  variant="h5"
                >
                  {index === 0
                    ? flightDetails?.cityTo
                    : flightDetails?.cityFrom}
                </Typography>
              </div>
              <Typography>
                {getFormattedStartDate(airport.segments[0].utc_departure)}
              </Typography>
            </div>
            <div>
              {airport.segments.map((segment, index) => (
                <>
                  <SegmentDetails segment={segment} />
                  {index < airport.segments.length - 1 && (
                    <div className={classes["segment-divider"]}>
                      <Box sx={{ display: "flex", gap: "1rem" }}>
                        <ScheduleIcon />
                        <Typography
                          className={classes["segment-divider__content"]}
                          component="span"
                        >
                          {getDateDifference(
                            airport.segments[index + 1].utc_departure,
                            segment.utc_arrival
                          )}{" "}
                          Layover
                        </Typography>
                      </Box>
                      {airport.segments[index + 1].vi_connection && (
                        <>
                          <Box sx={{ display: "flex", gap: "1rem" }}>
                            <LuggageIcon />
                            <Typography
                              className={classes["segment-divider__content"]}
                              component="span"
                            >
                              You must collect and recheck your baggage
                            </Typography>
                          </Box>

                          <Box sx={{ display: "flex", gap: "1rem" }}>
                            <ShoppingCartIcon />
                            <Typography
                              className={classes["segment-divider__content"]}
                              component="span"
                            >
                              Self transfer at {segment.cityFrom} ({" "}
                              {segment.flyFrom} )
                            </Typography>
                          </Box>
                        </>
                      )}
                    </div>
                  )}
                </>
              ))}
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  alignItems: "center",
                  marginLeft: "3rem",
                  padding: "1rem 0",
                }}
              >
                <WhereToVoteOutlined
                  width="12px"
                  height="12px"
                  stroke="#eaeaea"
                  strokeWidth="1px"
                />
                <Typography>Arrived at destination</Typography>
              </Box>
            </div>
          </div>
        ))}
        <div className={classes["modal-footer"]}>
          <div className={classes["modal-footer__content"]}>
            <Typography variant="h6" fontWeight={700}>
              {currency || "INR"} {Math.round(flightDetails.price)}
            </Typography>
            <button
              className={classes["modal-footer__action-btn"]}
              onClick={proceedToPayments}
            >
              <Typography
                variant="p"
                fontSize="1rem"
                fontWeight={700}
                color="white"
              >
                Book
              </Typography>
            </button>
          </div>
        </div>
      </>
    </Modal>
  );
}
